<form [formGroup]="extraUitgavenKledingEnBeddengoed">
    <div formArrayName="pgaExtraUitgavenKledingEnBeddengoed">
        <div *ngFor="let item of pgaExtraUitgavenKledingEnBeddengoed.controls; let i = index; "
             [formGroupName]="i" class="row">
            <snelstart-ui-select-form-control (change)="saveForm()"
                                              [label]="i === 0 ? 'Duur van de ziekte' : ''"
                                              [options]="itemsDuurZiekte"
                                              [required]=true
                                              class="col-auto custom-input-250"
                                              formControlName="duurZiekteMinimaalJaar"
                                              id="duurZiekteMinimaalJaar-{{i}}"
            >
            </snelstart-ui-select-form-control>
            <div [formGroup]="getPeriodeFormGroup(i)" class="row col-auto">
                <snelstart-ui-date-form-control (change)="saveForm()"
                                                [label]="i === 0 ? 'Begindatum' : ''"
                                                [required]=true
                                                class="col-auto custom-input-150"
                                                formControlName="begindatum"
                                                id="begindatum"
                                                placeholder="dd-mm-{{this.aangifte.aangifteJaar}}"

                >
                </snelstart-ui-date-form-control>
                <snelstart-ui-date-form-control (change)="saveForm()"
                                                [label]="i === 0 ? 'Einddatum' : ''"
                                                [required]=true
                                                class="col-auto custom-input-150"
                                                formControlName="einddatum"
                                                id="einddatum"
                                                placeholder="dd-mm-{{this.aangifte.aangifteJaar}}"
                >
                </snelstart-ui-date-form-control>
            </div>
            <div class="col-auto d-flex align-items-center">
                <snelstart-ui-select-form-control (change)="saveForm()"
                                                  [label]="i === 0 ? 'Hoogte van de uitgaven' : ''"
                                                  [options]="itemsJaNee"
                                                  class="custom-input-250"
                                                  formControlName="extraUitgavenKledingBeddengoedHogerDanMax"
                                                  id="extraUitgavenKledingBeddengoedHogerDanMax-{{i}}"
                >
                </snelstart-ui-select-form-control>
                <span *ngIf="i === 0" class="pt-1 ms-2"
                      snelstartUiTooltipPlacement="bottom"
                      snelstartUiTooltip="Zie de Toelichting voor het geldende grensbedrag">&#x24D8;</span>
            </div>
            <snelstart-ui-button (click)="verwijderRijExtraUitgavenKledingEnBeddengoed(i)"
                                 [class]="i === 0 ? 'firstrowbutton col-auto ' : 'col-auto '"
                                 icon="trash"
                                 iconType="light"
                                 id="buttonDeleteKosten"
                                 size="medium"
                                 type="secondary"
            >
            </snelstart-ui-button>
        </div>
    </div>
</form>

<div *ngIf="pgaExtraUitgavenKledingEnBeddengoed.length === 0">
    <snelstart-ui-button (click)="addRijExtraUitgavenKledingEnBeddengoed()" class="snelstart-ui-button pb-3" icon="plus"
                         type="link">Uitgaven kleding & beddengoed
    </snelstart-ui-button>
</div>
<div *ngIf="pgaExtraUitgavenKledingEnBeddengoed.length > 0">
    <snelstart-ui-button (click)="addRijExtraUitgavenKledingEnBeddengoed()" class="snelstart-ui-button pb-3" icon="plus"
                         type="link">Uitgaven kleding & beddengoed toevoegen
    </snelstart-ui-button>
</div>




